import { Component } from 'preact';
import { DOMAIN } from '@globals';

import Helmet from 'preact-helmet';
import style from './style';
import { SlotContent, Slot } from '@components/slots';
import Header from '@components/header';
import Breadcrumbs from '@components/breadcrumbs';

const buildMetaTags = (title, description, image, link) => {
  image = !image
    ? ''
    : image.includes('?')
    ? `${image}&auto=format`
    : image.includes('auto=format')
    ? image
    : `${image}?auto=format`;
  const titleTags = [
      { name: 'name' },
      { name: 'twitter:name' },
      { itemprop: 'name' },
      { property: 'og:title' },
    ],
    descriptionTags = [
      { name: 'description' },
      { name: 'twitter:description' },
      { itemprop: 'description' },
      { property: 'og:description' },
    ],
    imageTags = [
      { name: 'image' },
      { name: 'twitter:image' },
      { itemprop: 'image' },
      { property: 'og:image' },
    ],
    appTags = [
      {
        name: 'apple-itunes-app',
        content:
          'app-id=1596078295, appArgument=' +
          encodeURIComponent(window.location.href),
      },
    ];

  return {
    title,
    meta: [
      { property: 'og:site_name', content: 'TableOnline.fi' },
      { property: 'og:see_also', content: `${DOMAIN}/en` },
      { property: 'og:type', content: 'article' },
      { property: 'twitter:card', content: 'summary' },
      ...titleTags.map(property => ({ ...property, content: title })),
      ...descriptionTags.map(property => ({
        ...property,
        content: description,
      })),
      ...imageTags.map(property => ({ ...property, content: image })),
      ...appTags,
    ].filter(item => item.content),
    link: link
      ? link
          .map(item => {
            item.href =
              item.href.indexOf('/') === 0
                ? `${DOMAIN}${item.href}`
                : item.href;
            return item;
          })
          .map(item =>
            item.hreflang && item.hreflang === 'ee'
              ? { ...item, hreflang: 'et' }
              : item
          )
      : [],
  };
};

export class HeroWrapper extends Component {
  render(
    { breadcrumbs: propBreadcrumbs },
    state,
    { breadcrumbs: contextBreadcrumbs = [] }
  ) {
    // Use breadcrumbs from props if available, otherwise from context
    const breadcrumbs = propBreadcrumbs || contextBreadcrumbs;

    return (
      <header>
        <Header dark={true} />
        <div class={style.hero} hero-bg>
          <div class={`${style.heroTitle} contain`}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Slot name="hero">
              <div class={style.heroTitleContent}>
                <h1 placeholder key={'heroTitleH1Placeholder'}></h1>
                <h2 placeholder key={'heroTitleH2Placeholder'}></h2>
              </div>
            </Slot>
          </div>
        </div>
      </header>
    );
  }
}

class Hero extends Component {
  render({
    title,
    description,
    children,
    image = `https://img.tableonline.fi/restaurant/309/images/tableonline-309-alasti-I018418f53294.jpg?auto=format&fit=crop&w=${window.innerWidth}&q=80`,
    onlyChildren = false,
    link,
  }) {
    return (
      <SlotContent slot="hero">
        <div class={style.heroTitleContent}>
          {title && onlyChildren === false ? <h1>{title}</h1> : null}
          {description && onlyChildren === false ? (
            <h2>{description}</h2>
          ) : null}
          {children || null}
          <Helmet
            {...buildMetaTags(title, description, image, link)}
            onChangeClientState={() => [
              ...document.head
                .querySelectorAll('[data-preact-helmet="true"]')
                .forEach(el =>
                  document.head
                    .querySelector('title')
                    .insertAdjacentElement('afterEnd', el)
                ),
            ]}
          />
          {image ? (
            <style
              dangerouslySetInnerHTML={{
                __html: `[hero-bg] {background:url(${image}) 50% 50% / cover}`,
              }}
            />
          ) : null}
        </div>
      </SlotContent>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./components/hero/index.js